import styled from 'styled-components';
import { ColumnContainer } from '../container';

const Container = styled(ColumnContainer)`
  height: 14px;
  justify-content: space-between;
`;

export default Container;
